import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CurafidaAuthService } from '../authentication/curafida-auth.service';
import { Logger, LoggingService, LogLevel } from '../logging/logging.service';

@Injectable({
    providedIn: 'root',
})
export class MemberGuardService {
    protected readonly log: Logger;

    constructor(
        protected authService: CurafidaAuthService,
        private router: Router,
        private loggingService: LoggingService,
    ) {
        this.log = this.loggingService.getLogger(this.constructor.name);
        this.log.setLevel(LogLevel.INFO);
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<UrlTree | boolean> {
        if (this.authService.isAuthenticated()) {
            this.log.debug(`[canActivate] User is authenticated. Accessing /member/* is allowed. Return true.`);
            return true;
        }

        this.log.info(`[canActivate] User is NOT authenticated. Navigate to login page`);
        return this.router.createUrlTree(['login'], { queryParams: { redirect: state.url } });
    }
}
